import Head from "next/head";
// import { make as SetUpdatePage } from "../../src/info/SetUpdatePage.bs";
import { make as SetUpdatePage } from "../../src/set-update/Set9UpdatePage.bs";

export default function SetUpdate({ anomalies }) {
  return (
    <>
      <Head>
        <meta content={"Set 14 Update"} property="og:title" />
        <meta
          property="og:image"
          content={"https://ap.tft.tools/img/cd14/keyart.jpg"}
        />
        <meta name="twitter:card" content="summary_large_image" />
        <title>Set 14 Update</title>
      </Head>
      <SetUpdatePage anomalies={anomalies} />
    </>
  );
}

export async function getStaticProps({ locale }) {
  const anomaliesResp = await fetch(
    `https://ap.tft.tools/static/s13/anomalies_${locale}.json`,
  );
  const anomalies = await anomaliesResp.json();

  return {
    props: { anomalies },
    revalidate: 3600,
  };
}
